<template>
  <v-expand-transition v-if="show">
    <div
      v-if="message"
      :class="['flash-message', { warning: type === 'warning' }]"
      :style="{ backgroundColor: computedBackgroundColor }"
    >
      <div class="message">
        <AlertIcon
          :type="type"
          :color="computedBackgroundColor"
        />
        <slot>
          <div>
            <div>
              {{ message }}
            </div>
            <div
              v-if="actionText"
              class="mt-2 action-button"
              @click="$emit('actionClick')"
            >
              {{ actionText }}
            </div>
          </div>
        </slot>
      </div>
      <div
        class="close"
        @click.stop="$emit('close')"
      >
        <DpplSvg
          file-name="icon-close"
          data-testid="icon"
        />
      </div>
    </div>
  </v-expand-transition>
</template>

<script>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import AlertIcon from '@/components/shared/alerts/AlertIcon.vue';
import { useColors } from '@/composables/colors';

export default {
  name: 'FlashMessage',
  components: { DpplSvg, AlertIcon },
  props: {
    show: { type: Boolean, default: false },
    message: { type: String, default: null },
    type: { type: String, default: null },
    thisPageOnly: { type: Boolean, default: false },
    actionText: { type: String, default: '' },
  },
  emits: ['actionClick', 'close'],
  setup() {
    const {
      success,
      error,
      info,
      warning,
      brandPrimary,
    } = useColors();

    return {
      success,
      error,
      info,
      warning,
      brandPrimary,
    };
  },
  computed: {
    computedBackgroundColor() {
      const typeColorMap = {
        success: this.success,
        green: this.success,
        error: this.error,
        red: this.error,
        info: this.info,
        purple: this.brandPrimary,
        warning: this.warning,
      };
      if (this.type) {
        return typeColorMap[this.type];
      }
      return this.brandPrimary;
    },
  },
  mounted() {
    if (this.thisPageOnly) {
      const unsubscribe = this.$router && this.$router.afterEach((to, from) => {
        if (to.name !== from.name) {
          unsubscribe();
          this.$emit('close');
        }
      });
    }
  },
};
</script>

<style scoped lang="less">
.flash-message {
  margin: 8px auto 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 10px;
  color: @white;

  &.warning {
    color: @text-darkest;

    :deep(.close) svg path {
      fill: @white;
    }

    :deep(.alert-icon-wrapper) {
      background: @grey-900;

      svg path {
        fill: @basic-yellow;
      }
    }
  }
  .message {
    display: flex;
    justify-content: flex-start;
    text-align: left;
    width: 100%;
    padding: 16px;
  }
  .close {
    display: flex;
    padding: 20px 24px 0 24px;
    border-radius: 0 10px 10px 0;
    cursor: pointer;
    &:hover {
      background-color: rgba( 0, 0, 0, .1);
    }
  }
  .action-button {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
/* always present */
.expand-enter-active, .expand-leave-active {
  transition: all .3s ease;
  overflow: hidden;
}
/* .expand-enter defines the starting state for entering */
/* .expand-leave defines the ending state for leaving */
.expand-enter, .expand-leave-to {
  height: 0;
  padding: 0;
  opacity: 0;
}
</style>
